import {
  Alert,
  Box,
  Container,
  Paper,
  TableCell,
  TableRow,
} from "@mui/material";
import React from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import { useParams } from "react-router-dom";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";
import LabelValueList from "../../widgets/LabelValueList";

const ContactDetail = () => {
  const { id } = useParams();
  const { data, isLoading, isError, error } = useApiEp(
    `/user/get-contact/${id}`
  );
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <PageTitle>Contact Detail</PageTitle>
      <Paper sx={{ my: 2 }} elevation={0} variant="outlined">
        <LabelValueList data={data} />
      </Paper>
    </Container>
  );
};

export default ContactDetail;
